import { useReactiveVar } from '@apollo/client';
import { refreshTokenVar } from '../apollo/reactive-variables/auth';

const useIsLogged = () => {
  const refreshToken = useReactiveVar(refreshTokenVar);
  return !!refreshToken;
};

export default useIsLogged;
